import { environment } from "../../shared/utils/enum";
export const envConfig = {
  PUBLIC_URL: "https://markettracker.yarabrasil.com.br/",
  REACT_APP_ENVIRONMENT_NAME: environment.production,
  REACT_APP_NAME: "$npm_package_name",
  REACT_APP_VERSION: "$npm_package_version",
  REACT_APP_API_URL: "https://markettrackerprd.azurewebsites.net/api/v1/",
  REACT_APP_CLARITY_KEY: "a2n6djntai"
};
